import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import DNActions, { dnActionTypes } from '../actions/dnActions';
import DNServices from '../services/dnServices';

/**
 * @param action
 */
function* _createDN(action) {
  try {
    yield put(DNActions.createDNLoading(true));
    const dn = yield DNServices.createDN(action.payload);
    if (dn.success) {
      yield put(TrackerActions.trackAction(dnActionTypes.CREATE_DN.SUCCESS, dn.data));
      notification.open({
        type: 'success',
        message: 'Debit Note successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(dn?.data?.[0]);
      yield put(DNActions.createDNLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: dn.message,
        duration: 4,
        placement: 'top',
      });
      yield put(DNActions.createDNLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(DNActions.createDNLoading(false));
    yield put(TrackerActions.trackAction(dnActionTypes.CREATE_DN.ERROR, error));
  }
}

/**
 *
 */
function* createDN() {
  yield takeLatest(dnActionTypes.CREATE_DN.REQUEST, _createDN);
}

/**
 * @param action
 */
function* _updateDN(action) {
  try {
    yield put(DNActions.updateDNLoading(true));
    const dn = yield DNServices.updateDN(action.payload);
    if (dn.success) {
      yield put(TrackerActions.trackAction(dnActionTypes.UPDATE_DN.SUCCESS, dn.data));
      notification.open({
        type: 'success',
        message: 'Debit Note successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(DNActions.updateDNLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: dn?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(DNActions.updateDNLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(DNActions.updateDNLoading(false));
    yield put(TrackerActions.trackAction(dnActionTypes.UPDATE_DN.ERROR, error));
  }
}

/**
 *
 */
function* updateDN() {
  yield takeLatest(dnActionTypes.UPDATE_DN.REQUEST, _updateDN);
}

/**
 * @param action
 */
function* _getDN(action) {
  try {
    DNActions.getDNSuccess(null);
    yield put(DNActions.getDNLoading(true));
    const {
      tenantId, tenantSellerId, dnId, status, page, limit, searchKeyword, is_list
    } = action;
    const debitNotes = yield DNServices.getDN(tenantId, tenantSellerId, dnId, status, page, limit, searchKeyword, is_list);
    yield put(DNActions.getDNSuccess(debitNotes));
    yield put(DNActions.getDNLoading(false));
  } catch (error) {
    yield put(DNActions.getDNLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dnActionTypes.GET_DN.ERROR, error));
  }
}

/**
 *
 */
function* getDN() {
  yield takeLatest(dnActionTypes.GET_DN.REQUEST, _getDN);
}

/**
 * @param action
 */
function* _getDNById(action) {
  try {
    yield put(DNActions.getDNByIdLoading(true));
    const {
      tenantId, tenantSellerId, dnId, searchKeyword, callback
    } = action;
    const selectedDN = yield DNServices.getDN(tenantId, tenantSellerId, dnId, searchKeyword);
    yield put(DNActions.getDNByIdSuccess(selectedDN));
    if (callback) {
      callback(selectedDN);
    }
    yield put(DNActions.getDNByIdLoading(false));
  } catch (error) {
    yield put(DNActions.getDNByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dnActionTypes.GET_DN_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getDNById() {
  yield takeLatest(dnActionTypes.GET_DN_BY_ID.REQUEST, _getDNById);
}

/**
 * @param action
 */
function* _updateDNStatus(action) {
  try {
    yield put(DNActions.updateDNStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const dn = yield DNServices.updateDNStatus(payload);

    if (dn.success) {
      notification.open({
        type: 'success',
        message: 'Debit Note successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dn?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DNActions.updateDNStatusLoading(false));
  } catch (error) {
    yield put(DNActions.updateDNStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dnActionTypes.UPDATE_STATUS_DN.ERROR, error));
  }
}

/**
 *
 */
function* updateDNStatus() {
  yield takeLatest(dnActionTypes.UPDATE_STATUS_DN.REQUEST, _updateDNStatus);
}

/**
 * @param action
 */
function* _deleteDN(action) {
  try {
    yield put(DNActions.deleteDNLoading(true));
    const dn = yield DNServices.deleteDN(action.payload);

    if (dn.success) {
      notification.open({
        type: 'success',
        message: 'Debit Note successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dn?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DNActions.deleteDNLoading(false));
  } catch (error) {
    yield put(DNActions.deleteDNLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dnActionTypes.DELETE_DN.ERROR, error));
  }
}

/**
 *
 */
function* deleteDN() {
  yield takeLatest(dnActionTypes.DELETE_DN.REQUEST, _deleteDN);
}

/**
 * @param action
 */
function* _updateDNWorkflowStep(action) {
  try {
    yield put(DNActions.updateDNWorkflowStepLoading(true));
    const so = yield DNServices.updateDNWorkflowStep(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Debit Note successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DNActions.updateDNWorkflowStepLoading(false));
  } catch (error) {
    yield put(DNActions.updateDNWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dnActionTypes.UPDATE_DN_WORKFLOW_STEP.ERROR, error));
  }
}

/**
 *
 */
function* updateDNWorkflowStep() {
  yield takeLatest(dnActionTypes.UPDATE_DN_WORKFLOW_STEP.REQUEST, _updateDNWorkflowStep);
}

/**
 *
 */
export default function* dnSaga() {
  yield all([
    createDN(), getDN(), updateDN(), getDNById(), updateDNStatus(), deleteDN(), updateDNWorkflowStep(),
  ]);
}
